// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"62":"brand-rigging","155":"brand-danfloss","801":"brand-arg"}[chunkId] || chunkId) + "." + {"62":"3db0c3a2","148":"90076712","155":"5f57cf6b","217":"47f725f9","765":"47ef138b","801":"00b0346c","888":"176a3f56","934":"dab3070b"}[chunkId] + ".chunk.js";
};